import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import sanityClient from "../../client";
import BlockContent from "@sanity/block-content-to-react";
import NavAr from "./NavAr";
import FooterAr from "./FooterAr";
import Loading from "../components/Loading";

function HomeAr() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const arabic = { direction: "rtl" };

  useEffect(() => {
    const query = `
    *[_type=="home"]{
      "about": aboutUs.ar,
      "headerDesc": headerDescription.ar,
      "headerImage": headerImage.asset->url,
      "headerTitle": headerTitle.ar,
      "note": note.ar,
      "project": project->{
        "slug": Slug.current,
        "address": address.ar,
        "name": name.ar,
        "image": images[0].asset->url
      },
      "properties": properties[]->{
        "slug": Slug.current,
        "name": name.ar,
        "image": images[0].asset->url,
        availability
      },
      "serviceImage": serviceImage.asset->url,
      "services": services.ar,
      "numbers": Numbers[]{
        number,
        "numberDesc": numberDesc.ar
      }
    }
  `;

    sanityClient
      .fetch(query)
      .then((data) => {
        setData(data[0]);
        setLoading(false);
      })
      .catch((err) => console.log(err));

      document.title = "الرئيسية - CompanyName";
      document.querySelector("html").lang = "ar";
  }, []);

  if (loading) {
    return <Loading />;
  }
  const {
    about,
    headerDesc,
    headerImage,
    headerTitle,
    note,
    project,
    properties,
    serviceImage,
    services,
    numbers,
  } = data;
  const style = {
    textAlign: "right",
  };
  return (
    <>
     <NavAr url="/" />
    <div style={arabic}>
      <header>
        <div className="left">
          <div className="center" style={style}>
            <h1>
              {/* Delivering high quality <span>Appartments</span>, with a nice
              price */}
              {headerTitle}
            </h1>
            <p>{headerDesc}</p>
            <Link to="/contact">تواصل معنا</Link>
          </div>
        </div>
        <div className="right">
          <img src={headerImage} alt="gt-home img" />
        </div>
      </header>
      <div className="about">
        <h2>معلومات عنا</h2>
        <p>{about}</p>
        <p className="note">ملاحظة: {note} </p>
      </div>
      <div className="services">
        <div className="left">
          <img src={serviceImage} alt="gt-home img" />
        </div>
        <div className="right">
          <h2 style={style}>خدماتنا الرئيسية</h2>
          <BlockContent blocks={services} />
        </div>
      </div>
      <div className="project">
        <div className="left">
          <h3>{project.address}</h3>
          <h2 style={style}>{project.name}</h2>
          <Link to={"/ar/projects/" + project.slug}>عرض المشروع</Link>
        </div>
        <div className="right">
          <img src={project.image} alt="gt-home img" />
        </div>
      </div>

      <div className="apartments">
        {/* <h2>Properties</h2> */}
        <div className="content">
          {properties.map(({ slug, name, image }) => {
            return (
              <div className="apartment" key={slug}>
                <Link to={"/ar/properties/" + slug}>
                  <img src={image} alt="gt home img" />
                  <h4>{name}</h4>
                </Link>
              </div>
            );
          })}
        </div>
      </div>

      <div className="numbers">
        <h2>بعض الأرقام</h2>
        <div className="num-container">
          {numbers.map(({ number, numberDesc }, index) => {
            return (
              <div className="num" key={index}>
                <span>{number}+</span>
                <h4>{numberDesc}</h4>
              </div>
            );
          })}
        </div>
      </div>

      <div className="contact" id="contact-sec">
        <h2>اتصل بنا</h2>
        <p>نحن في الخدمة. نضع تحت تصرفكم الأرقام التالية للحجز والاستعلام</p>
        <div className="info-container">
          <div className="con-info">
            <h3>Ahmed El amine</h3>
            <span>0557745847</span>
          </div>
          <div className="con-info">
            <h3>Ahmed El amine</h3>
            <span>0557745847</span>
          </div>
          <div className="con-info">
            <h3>Ahmed El amine</h3>
            <span>0557745847</span>
          </div>
        </div>
      </div>
    </div>
    <FooterAr />
    </>
  );
}

export default HomeAr;
